var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgToggleOpen = function SvgToggleOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.65 1.5a.65.65 0 1 0-1.3 0v3.85H1.5a.65.65 0 1 0 0 1.3h3.85v3.85a.65.65 0 1 0 1.3 0V6.65h3.85a.65.65 0 1 0 0-1.3H6.65V1.5Z",
    fill: "currentColor"
  })));
};

export { SvgToggleOpen as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIiBmaWxsPSJub25lIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjY0OTYxIDEuNTAwMUM2LjY0OTYxIDEuMTQxMTEgNi4zNTg1OSAwLjg1MDA5OCA1Ljk5OTYxIDAuODUwMDk4QzUuNjQwNjIgMC44NTAwOTggNS4zNDk2MSAxLjE0MTExIDUuMzQ5NjEgMS41MDAxVjUuMzUwMUwxLjQ5OTYxIDUuMzUwMUMxLjE0MDYyIDUuMzUwMSAwLjg0OTYwOSA1LjY0MTExIDAuODQ5NjA5IDYuMDAwMUMwLjg0OTYwOSA2LjM1OTA4IDEuMTQwNjIgNi42NTAxIDEuNDk5NjEgNi42NTAxSDUuMzQ5NjFWMTAuNTAwMUM1LjM0OTYxIDEwLjg1OTEgNS42NDA2MiAxMS4xNTAxIDUuOTk5NjEgMTEuMTUwMUM2LjM1ODU5IDExLjE1MDEgNi42NDk2MSAxMC44NTkxIDYuNjQ5NjEgMTAuNTAwMVY2LjY1MDFIMTAuNDk5NkMxMC44NTg2IDYuNjUwMSAxMS4xNDk2IDYuMzU5MDggMTEuMTQ5NiA2LjAwMDFDMTEuMTQ5NiA1LjY0MTExIDEwLjg1ODYgNS4zNTAxIDEwLjQ5OTYgNS4zNTAxTDYuNjQ5NjEgNS4zNTAxVjEuNTAwMVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";